/// <reference path='../../../../typings/hibachiTypescript.d.ts' />
/// <reference path='../../../../typings/tsd.d.ts' />

import {Order_AddOrderPayment} from "./order_addorderpayment";


export {Order_AddOrderPayment}


// WEBPACK FOOTER //
// /home/circleci/project/org/Hibachi/client/src/core/model/process/processes.ts